import { Component, OnInit, ViewChild, Input, Output, } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms'
import { CallAPIService } from '../../../services/call-api.service';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router' ;
import { CloseDropdownService } from '../../../services/close-dropdown.service';
import { House } from '../../../interfaces/house.interface';




@Component({
  selector: 'house-select',
  template: `
      <div 
        class="btn-group dropdown-group" 
        dropdown #houseDrop="bs-dropdown" [autoClose]="false">
          
        <input #houseControl="ngModel" type="text" 
          class="routeInputs inline-block inputShorted " 
          id="house" name="hse" #houseInput placeholder="Введіть номер будинку та виберіть зі списку" 
          (keyup)="houseNumberTyped()" [(ngModel)]="house" autocomplete="off" />

        <ul [hidden]="! ( isShowHousesList && isCloseHousesPresent() )" id="dropdown-triggers-manual" *dropdownMenu class="houses-dropdown-menu"
            role="menu" aria-labelledby="button-triggers-manual">
          <div role="menuitem" *ngFor="let house of closeHouses" >
            <button type="button" class="dropdown-item" id="{{'H'+house.HOUSENUMBER_UA}}"
            (click)="selectHouse( house, $event.target.innerText ); isShowHousesList = false; "  >
              {{ toUpper( house.HOUSENUMBER_UA ) }}
            </button>
          </div>
          
        </ul>

        <button type="button" [disabled]="! isCloseHousesPresent() "
          [ngClass]="dropdownButtonClass"  
          class="btn btn-white dropdown-toggle-split dropButton greyDropdown" 
          (click)=" isShowHousesList = ! isShowHousesList ; "
          formnovalidate="formnovalidate" >
            <i class="fas fa-caret-down"></i>
        </button>

  `,
  styleUrls: ['./house-select.component.sass']
})
export class HouseSelectComponent implements OnInit {

  closeHouses: Array< House > = [] ;
  house ;
  isShowHousesList: boolean = false;
  dropdownButtonClass: string;
  lastResponseTime: any = null;
  lastHousePrefix: string ;

  @ViewChild('houseDrop', {static: true} ) houseDrop;
  @ViewChild('houseInput', {static: true} ) houseInput;
  @ViewChild('houseControl', {static: true} ) houseControl: NgModel ;

  @Input('form') form: NgForm;
  @Input('indexSync') indexSync: BehaviorSubject<string> ;
  @Output('postindex') postIndex = new BehaviorSubject( undefined ); 
  @Output('newValue') newValue: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(
    private API : CallAPIService, 
    private router: Router,
    private closeDropdown: CloseDropdownService,
    ) { 

    API.getHousesObservable().subscribe( newHouses => {
      if( newHouses != undefined  ){
        this.lastResponseTime = Date.now();
        this.closeHouses = newHouses ;
        this.isShowHousesList = true ;
        if( this.houseDrop != undefined )
          this.houseDrop.show();


      }
    })



    this.closeDropdown.addDropdown( 'housesDropdown' ).subscribe( ( needToClose )=>{
      if( needToClose ){
        let currentResponseTime = Date.now() ;
        let timeInterval 
        if( this.lastResponseTime == null )
          timeInterval = 100000 ;
        else
          timeInterval = currentResponseTime - this.lastResponseTime ;
        
        if( needToClose == true && this.isShowHousesList == true && timeInterval > 1000 ){
          this.isShowHousesList = false ;
          if( this.houseDrop != undefined )
            this.houseDrop.hide();

        }

      }
    } )
  }

  ngOnInit() {
  
    this.form.addControl( this.houseControl );

    this.API.getClearSubject().asObservable().subscribe( clear => {

      if( clear ){
        this.closeHouses = [];
        this.houseControl.control.setValue('')
      }
    }  )


  }


  selectHouse( selectedHouseObj, str ='' ){
    
    this.houseDrop.hide();
    if( str )
      this.form.controls['hse'].setValue( str ) ;
    this.indexSync.next( selectedHouseObj.POSTCODE )

    this.newValue.next( selectedHouseObj )
  }

  toUpper(  str : string ): string {

    return str.toLocaleUpperCase() ;
  }

  isCloseHousesPresent():boolean{
    if( this.closeHouses == undefined || this.closeHouses.length == undefined )
      return false
    return  ( this.closeHouses.length as unknown as boolean || false )
  }

  houseNumberTyped(  ){
    let typedHouseNumber = this.house ;
    let houseObject ;
    if( this.lastHousePrefix && this.house && this.lastHousePrefix.length != this.house.length || ! this.house )
      this.newValue.next( null )
    this.lastHousePrefix = this.house
    
    for( let i=0; i < this.closeHouses.length ; ++i){
      if( this.closeHouses[i].HOUSENUMBER_UA.toLocaleLowerCase().trim() == typedHouseNumber.toLocaleLowerCase().trim() )
        houseObject = this.closeHouses[i];
    }
    
    
    if( houseObject ){
      this.selectHouse( houseObject );
      
    }
  }
}
